module.exports = __webpack_public_path__ + "img/signs8.de82dca4.jpg";